import { enqueueActions } from 'xstate';

import { type CustomizationMachineAction } from '../../types';
import { calculateCalories } from './calculate-calories';
import { calculateNetPrice } from './calculate-net-price';
import { generateModifiers } from './generate-modifiers';
import { optimizeIncludedSlots } from './optimize-included-slots';
import { raiseChangeToOnTheSideIfNeeded } from './raise-change-to-on-the-side-if-needed';
import { raiseGenerateMixedDressingDetailsEvent } from './raise-generate-mixed-dressing-event';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Updates the state of modifications after a change has occurred in
 * the customization process.
 */
export const updateModificationAfterChange: CustomizationMachineAction = enqueueActions((args) => {
  const { enqueue } = args;

  enqueue(optimizeIncludedSlots);
  enqueue(generateModifiers);
  enqueue(raiseChangeToOnTheSideIfNeeded);
  enqueue(raiseGenerateMixedDressingDetailsEvent);
  enqueue(calculateCalories);
  enqueue(calculateNetPrice);
});
